"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceAreaTick = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var styles_1 = require("../../styles");
var string_1 = require("../../util/string");
var MAX_CHARS_PER_LINE = 8;
var TICK_MARGIN = 5;
var TICK_X_DISLOCATION = 15;
var TICK_Y_DISLOCATION = 15;
function ReferenceAreaTick(props) {
    var _a, _b, _c, _d, _e;
    var x = props.x, y = props.y, payload = props.payload, refTicks = props.refTicks, height = props.height;
    var ref = refTicks.get(+payload.value);
    var theme = styles_1.useTheme();
    var nameLines = string_1.splitIntoLines(ref.name, MAX_CHARS_PER_LINE);
    var description = ref.description;
    var textYOffset = (_a = ref.textYOffset) !== null && _a !== void 0 ? _a : 0;
    var rectangleHeight = (ref.areaPercents.slice(-1)[0].percent / 100) * height - TICK_MARGIN / 2;
    var alignDescriptionOffset = ((_b = ref.description) === null || _b === void 0 ? void 0 : _b.align) === 'bottom' ? rectangleHeight : nameLines.length * TICK_Y_DISLOCATION + TICK_MARGIN;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("text", { x: x, y: y, dx: TICK_X_DISLOCATION, dy: TICK_Y_DISLOCATION, textAnchor: 'start', fill: (_c = ref.tickColor) !== null && _c !== void 0 ? _c : ref.color, style: { fontWeight: 'bold' } }, nameLines.map(function (namePart, i) {
            return namePart && (react_1.default.createElement("tspan", { key: namePart, dx: TICK_X_DISLOCATION, dy: (i + 1) * TICK_Y_DISLOCATION, x: x, y: y + textYOffset }, namePart));
        })),
        description && (react_1.default.createElement("text", { x: x + TICK_X_DISLOCATION, y: y + 5 + nameLines.length * TICK_Y_DISLOCATION, dx: TICK_X_DISLOCATION, dy: TICK_Y_DISLOCATION, textAnchor: 'start', fill: (_d = description.color) !== null && _d !== void 0 ? _d : theme.pallete.text.main, style: description.style }, string_1.splitIntoLines(description.text, MAX_CHARS_PER_LINE).map(function (descriptionPart, i) {
            return descriptionPart && (react_1.default.createElement("tspan", { key: descriptionPart, dx: TICK_X_DISLOCATION, dy: (i + 1) * TICK_Y_DISLOCATION, x: x, y: y + textYOffset + alignDescriptionOffset }, descriptionPart));
        }))),
        react_1.default.createElement(recharts_1.Rectangle, { x: x, y: y, dx: 15, dy: TICK_MARGIN / 2, width: 4, height: rectangleHeight, fill: (_e = ref.tickColor) !== null && _e !== void 0 ? _e : ref.color })));
}
exports.ReferenceAreaTick = ReferenceAreaTick;
//# sourceMappingURL=ReferenceAreaTick.js.map